import { render, staticRenderFns } from "./DialogCreateEditNotification.vue?vue&type=template&id=1a4d1a1e&scoped=true"
import script from "./DialogCreateEditNotification.js?vue&type=script&lang=js&external"
export * from "./DialogCreateEditNotification.js?vue&type=script&lang=js&external"
import style0 from "./DialogCreateEditNotification.vue?vue&type=style&index=0&id=1a4d1a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d1a1e",
  null
  
)

export default component.exports